var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen flex w-full",attrs:{"id":"page-login"}},[_c('div',{staticClass:"mx-auto self-center",staticStyle:{"width":"400px"}},[_c('Card',[_c('EmployeeRegisterByInvitationForm')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }